import { Component, OnInit } from '@angular/core';
import { Gdpr, PeopleData } from './gdpr.model';
import { ContactAddress } from './ContactAddress.model';
import { GDPRContact } from './GdprContact.model';
import { Router, ActivatedRoute } from '@angular/router';
import { GdprService } from './gdpr.service';
import { ServiceGuard } from '../_guards/service.guard';
import { EnvironmentSpecificService } from '../environs/services/environment-specific.service';
import { GiftCardService } from '../gift-card/gift-card.service';

@Component({
  selector: 'app-gdpr',
  templateUrl: './gdpr.component.html',
  styleUrls: ['../app.component.css']
})
export class GdprComponent implements OnInit {

  id: number;
  display = 'none';
  valueofparam: any;
  loading = false;
  selected1 = false;
  selected2 = false;
  selected3 = false;
  selected4 = false;
  disableSubmit: boolean;
  disableSubmitdisplay: any;
  displayWarning: boolean;
  displayWarningShow: any;
  dispalyTechError: boolean;
  disablemailingAddress: boolean;
  statustobe: string;
  primaryAddress: string;
  mailingAddress: string;
  defaultDataText = 'Not available';
  privacynotice = '/#/privacy-notice';
  apacenprivacynotice: string;
  gdpr: Gdpr;
  disableENPrivacy: any;
  Language: string;
  contactAddress: ContactAddress;
  isHashCodeStartWithDP = false;
  peopleData: PeopleData = new PeopleData();
  isUpdateMyInfoModalVisible = false;
  isActionFlagC = false;
  isActionFlagCModalVisible = false;
  constructor(private readonly gdprService: GdprService,
    private readonly _serviceGaurd: ServiceGuard,
    private readonly envSpecificSvc: EnvironmentSpecificService,
    private readonly activatedRoute: ActivatedRoute,
    private readonly giftCardService: GiftCardService,
    private readonly _router: Router) {

    this.gdpr = new Gdpr();
    this.contactAddress = new ContactAddress();
    this.displayWarning = false;
    this.displayWarningShow = 'none';
  }

  public async ngOnInit() {
    this.Language = window.location.href;
    this.loading = true;
    this.disableSubmitdisplay = 'none';
    this.valueofparam = this.activatedRoute
      .queryParams
      .subscribe(params => {
        // tslint:disable-next-line:radix
        this.id = +parseInt(atob(params['contactId'])) || 0;
        const hashCode: string = sessionStorage.getItem('hashCode') || '';
        this.isHashCodeStartWithDP = hashCode.startsWith('dp-');
        console.log(this.isHashCodeStartWithDP);
        if (this.isHashCodeStartWithDP) {
          const peopleData = this.gdprService.userData;
          if (peopleData && peopleData.length > 0) {
            this.contactsDetailV2(peopleData);
          } else {
            this._router.navigate(['/']);
          }
        }
      });
    if (this.Language.indexOf('/en-ap/') !== -1) {
      this.privacynotice = '/en-ap/#/apac-en-privacy-notice';
    }
    if (this.Language.indexOf('/cn/') !== -1) {
      this.apacenprivacynotice = '/cn/#/apac-en-privacy-notice';
      this.privacynotice = '/cn/#/privacy-notice';
    }
    if (this.Language.indexOf('/tw/') !== -1) {
      this.apacenprivacynotice = '/tw/#/apac-en-privacy-notice';
      this.privacynotice = '/tw/#/privacy-notice';
    }
    if (this.Language.indexOf('/hk/') !== -1) {
      this.apacenprivacynotice = '/hk/#/apac-en-privacy-notice';
      this.privacynotice = '/hk/#/privacy-notice';
    }
    if (this.Language.indexOf('/jp/') !== -1) {
      this.apacenprivacynotice = '/jp/#/jp-en-privacy-notice';
      this.privacynotice = '/jp/#/jp-en-privacy-notice';
    }
    if (this.Language.indexOf('/sa/') !== -1) {
      this.privacynotice = '/sa/#/sa-privacy-notice';
    }
    if (this.Language.indexOf('/au/') !== -1) {
      this.privacynotice = '/au/#/apac-en-privacy-notice';
    }
    if (this.Language.indexOf('/sk/') !== -1) {
      this.privacynotice = '/sk/#/apac-en-privacy-notice';
    }
    if (this.Language.indexOf('/ch/') !== -1) {
      this.privacynotice = '/ch/#/ch-privacy-notice';
    }
    if (this.Language.indexOf('/br/') !== -1) {
      this.privacynotice = '/br/#/br-privacy-notice';
    }

    if (this.Language.indexOf('/cn/') !== -1 || this.Language.indexOf('/tw/') !== -1 || this.Language.indexOf('/hk/') !== -1
      || this.Language.indexOf('/jp/') !== -1) {
      this.disableENPrivacy = 'block';
    } else {
      this.disableENPrivacy = 'none';
    }
    if (this.isHashCodeStartWithDP) {
      console.log('isHashCodeStartWithDP');
    } else {
      this.giftCardService.fetchToken((isSuccess) => {
        console.log(isSuccess);
        if (isSuccess) {
          this.loadContacts(this.id);
        } else {
          this.loading = false;
        }
      });
    }
  }

  contactsDetail(gdpr, contactId) {
    if (!gdpr.object || gdpr.object.length === 0) {
      return;
    }

    this.gdpr = gdpr.object[0];
    this.gdpr.contactId = contactId;

    this.setGdprStatus();
    this.extractContactAddresses();
    this.checkMailingAddress();
    this.loading = false;
  }

  setGdprStatus() {
    if (this.gdpr.gdprStatus != null) {
      this.disableSubmit = true;
      this.disableSubmitdisplay = 'block';

      switch (this.gdpr.gdprStatus) {
        case 'F':
          this.statustobe = '1';
          break;
        case 'D':
          this.statustobe = '2';
          break;
        case 'B':
          this.statustobe = '3';
          break;
        case 'T':
        case 'A':
        case 'I':
          this.statustobe = '4';
          break;
        case 'E':
          this.statustobe = '2 & 3';
          break;
        default:
          this.disableSubmit = false;
          this.disableSubmitdisplay = 'none';
          this.statustobe = '';
          break;
      }
    }
  }

  extractContactAddresses() {
    const primaryCompany = this.gdpr.contactCompanies?.find(company => company.isPrimaryCompany);

    if (primaryCompany) {
      primaryCompany.contactAddresses.forEach(address => {
        if (address.addressType === 1) {
          this.primaryAddress = this.formatAddress(address);
        } else {
          this.mailingAddress = this.formatAddress(address);
        }
      });
    }
  }

  checkMailingAddress() {
    if (this.primaryAddress && this.mailingAddress && (this.primaryAddress !== this.mailingAddress)) {
      this.disablemailingAddress = true;
    }
  }
  contactsDetailV2(peopleData) {
    this.peopleData = peopleData[0];
    if (this.peopleData.isHashCodeExpired) {
      this._router.navigate(['/error']);
      return;
    }
    if (!this.peopleData.eventDetails) {
      this.peopleData.eventDetails = [];
    }
    if (this.peopleData.actionFlag) {
      switch (this.peopleData.actionFlag) {
        case 'P':
          this.disableSubmitdisplay = 'none';
          break;
        case 'F':
          this.selected1 = true;
          this.statustobe = '1';
          this.disableSubmit = true;
          this.disableSubmitdisplay = 'block';
          break;
        case 'C':
          this.isActionFlagC = true;
          this.isActionFlagCModalVisible = true;
          this.disableSubmit = true;
          break;
        case 'T':
          this.statustobe = '2';
          this.disableSubmit = true;
          this.disableSubmitdisplay = 'block';
          this.selected4 = true;
          break;
        default:
          this.disableSubmit = false;
          this.disableSubmitdisplay = 'none';
          this.statustobe = '';
          this._router.navigate(['/error']);
          break;
      }
    }
  }
  loadContacts(contactId: number) {
    this.display = 'none';
    this.loading = true;
    this.gdprService.get(contactId, this.envSpecificSvc.envSpecific).subscribe(gdpr => {
      this.contactsDetail(gdpr, contactId);
    },
      err => {
        this.loading = true;
        if (err._body != null) {
          contactId = JSON.parse(err._body).object.newList[0];
          this.gdprService.get(contactId, this.envSpecificSvc.envSpecific).subscribe(gdpr => {
            this.contactsDetail(gdpr, contactId);
          },
            () => {
              this.dispalyTechError = true;
              this.loading = false;
              return;
            });
        } else {
          this.dispalyTechError = true;
          this.loading = false;
        }
        return;
      });
    this.loading = true;
  }

  formatAddress = function (contact) {
    let formattedAddress = '';
    if (!!contact.streetName) { formattedAddress += contact.streetName + ', '; }
    if (!!contact.streetName2) { formattedAddress += contact.streetName2 + ', '; }
    if (!!contact.streetName3) { formattedAddress += contact.streetName3 + ', '; }
    if (!!contact.cityName) { formattedAddress += contact.cityName + ', '; }
    if (!!contact.stateName) { formattedAddress += contact.stateName + ' '; }
    if (!!contact.zipCode) { formattedAddress += contact.zipCode + ', '; }
    if (!!contact.countryName) { formattedAddress += contact.countryName; }
    // formattedAddress='ioioioioioi iiioioi ihjhjhjhh hkjjkjkjkj k kk kkk lkl jjsjss kkks kskkks kskks kskks ksklslsllslsl sllslsls '
    return formattedAddress;
  };

  toggleSelect1 = function (event) {
    const selectAll = event.target.checked;
    if (selectAll) {
      this.selected2 = false;
      this.selected3 = false;
      this.selected4 = false;
      this.displayWarning = false;
      this.displayWarningShow = 'none';
    }
  };

  toggleSelect4 = function (event) {
    const selectAll = event.target.checked;
    if (selectAll) {
      this.selected2 = false;
      this.selected3 = false;
      this.selected1 = false;
      this.displayWarning = false;
      this.displayWarningShow = 'none';
    }
  };

  toggleSelect2and3 = function (event) {
    const selectAll = event.target.checked;
    if (selectAll) {
      this.selected1 = false;
      this.selected4 = false;
      this.displayWarning = false;
      this.displayWarningShow = 'none';
    }
  };

  modalOpen = function () {
    this.display = 'block';
  };

  modalClose = function () {
    this.display = 'none';
    this.selected4 = false;
  };

  modalCloseOkbutton = function () {
    this.disableSubmitdisplay = 'none';
  };

  modalCloseOkWarning = function () {
    this.displayWarningShow = 'none';
  };

  confirmToOptOut = function () {
    if (this.isHashCodeStartWithDP) {
      this.peopleData.actionFlag = 'T';
      const createdDateTime = new Date().toISOString();
      this.peopleData.eventDetails.push({
        eventType: 'Opt-out',
        description: 'Opted out of all communications',
        createdDateTime,
        eventFlag: this.peopleData.actionFlag
      });
      this.peopleData.lastModifiedDateTime = new Date().toISOString();
      this.postPeopleData();
      return;
    }
    const contactsList: GDPRContact[] = [];
    const g = this.gdpr;
    this.loading = true;
    g.gdprStatus = 'T';
    const gdprcontact = new GDPRContact;
    gdprcontact.contactId = g.contactId;
    gdprcontact.optOutFlag = g.gdprStatus;
    contactsList.push(gdprcontact);
    if (contactsList.length > 0) {
      const contact = { 'ListContacts': contactsList };
      this.loading = true;
      this.gdprService.create(contact, this.envSpecificSvc.envSpecific).subscribe(() => {
        this._router.navigate(['/success']);
        this.loading = false;

      }, err => {
        this.loading = false;
        this.dispalyTechError = true;
      });
    }
  };

  checkForStatusUpdate() {
    if ((this.selected1 === false || this.selected1 === undefined) && (this.selected2 === false || this.selected2 === undefined) &&
      (this.selected3 === false || this.selected3 === undefined) && (this.selected4 === false || this.selected4 === undefined)) {
      this.displayWarning = true;
      this.displayWarningShow = 'block';
      this.loading = false;
      return true;
    }
  }

  gdprOpted(event: Event) {
    const contactsList: GDPRContact[] = [];
    const g = this.gdpr;
    this.loading = true;

    if (this.selected1) {
      g.gdprStatus = 'F';
    }
    if (this.selected2) {
      g.gdprStatus = 'D';
    }
    if (this.selected3) {
      g.gdprStatus = 'B';
    }
    if (this.selected4) {
      g.gdprStatus = 'T';
      this.modalOpen();
      this.loading = false;
      return;
    }
    if (this.selected2 && this.selected3) {
      g.gdprStatus = 'E';
    }
    if (this.checkForStatusUpdate()) {
      return;
    }
    const gdprcontact = new GDPRContact;
    gdprcontact.contactId = g.contactId;
    gdprcontact.optOutFlag = g.gdprStatus;
    contactsList.push(gdprcontact);
    if (contactsList.length > 0) {
      const contact = { 'ListContacts': contactsList };
      this.loading = true;
      this.gdprService.create(contact, this.envSpecificSvc.envSpecific).subscribe(() => {
        this._router.navigate(['/success']);
        this.loading = false;

      }, err => {
        this.loading = false;
        this.dispalyTechError = true;
      });
    }
  }
  peopleDataOpted() {
    if (this.selected1) {
      this.peopleData.actionFlag = 'F';
      const createdDateTime = new Date().toISOString();
      this.peopleData.eventDetails.push({
        eventType: 'Elected no change',
        description: 'Elected no change',
        createdDateTime,
        eventFlag: this.peopleData.actionFlag
      });
      this.peopleData.lastModifiedDateTime = new Date().toISOString();
    }
    if (this.selected4) {
      this.peopleData.actionFlag = 'T';
      this.modalOpen();
      return;
    }
    if (this.checkForStatusUpdate()) {
      return;
    }
    this.postPeopleData();
  }
  private postPeopleData() {
    this.giftCardService.postPeopleData(this.peopleData, (res) => {
      if (res) {
        this._router.navigate(['/success']);
      } else {
        this.dispalyTechError = true;
      }
    });
  }
  submitUpdateNotes() {
    this.peopleData.actionFlag = 'C';
    const createdDateTime = new Date().toISOString();
    this.peopleData.eventDetails.push({
      eventType: 'UpdateNotes',
      description: 'Update notes for contact',
      createdDateTime,
      eventFlag: this.peopleData.actionFlag
    });
    this.peopleData.lastModifiedDateTime = new Date().toISOString();
    this.postPeopleData();
  }
}
